function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M30,2H2C0.9,2,0,2.9,0,4v24c0,1.1,0.9,2,2,2h28c1.1,0,2-0.9,2-2V4C32,2.9,31.1,2,30,2z M28,26H14.979l5.702-7.639L28,20.86  V26z M28,16.635l-6-2.05C21,14.234,20.484,14,20,14c-0.703,0-1.25,0.281-2,1.266L9.986,26H4V6h24V16.635z M10,16  c2.209,0,4-1.791,4-4s-1.791-4-4-4s-4,1.791-4,4S7.791,16,10,16z"
});

var SvgAttachImage = function SvgAttachImage(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    height: "32px",
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    viewBox: "0 0 32 32",
    width: "32px",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAttachImage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/attach-image.3c957910.svg";
export { ForwardRef as ReactComponent };